<template>
  <div class="card no-padding">
    <div class="change-title flex-align">
      <span class="change-title__label">发布变更时间</span>
      <span class="change-title__content">{{ changeTime }}</span>
    </div>
    <div class="section">
      <div class="section-title change-content-title">{{ noticeTitle }}</div>

      <div class="section-title">
        <base-section-title title="变更内容" />
      </div>
      <div class="section-content">
        <slot></slot>
      </div>
    </div>

    <div class="section">
      <div class="section-title">
        <base-section-title title="变更公告" />
      </div>
      <div class="section-content">
        <el-form class="detail-form">
          <el-form-item>
            <u-editor disabled :value="noticeContent" />
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import BaseSectionTitle from '@/components/common/BaseSectionTitle'
import UEditor from '@/components/common/UEditor/index.vue'

export default {
  name: 'BaseChangeCard',

  components: {
    BaseSectionTitle,
    UEditor
  },

  props: {
    changeTime: {
      type: String,
      default: ''
    },

    noticeTitle: {
      type: String,
      default: ' - '
    },

    noticeContent: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/variable.scss';

.change-title {
  width: 100%;
  height: pixel-to-rem($n: 60);
  background-color: $primary-background-color;
  box-sizing: border-box;
  padding: pixel-to-rem($n: 20) pixel-to-rem($n: 50);
  margin-bottom: pixel-to-rem($n: 20);

  .change-title__label {
    font-size: pixel-to-rem($n: 20);
    @include text-bold;

    margin-right: pixel-to-rem($n: 30);
  }
}

.change-content-title {
  text-align: center;
  font-size: pixel-to-rem($n: 22);
  @include text-bold;
}
</style>
